var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 38.75,
    viewBox: "0 0 36 38.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 32.886,
    height: 38.75,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Animation",
    transform: "translate(-569 -3952.786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow",
    width: 33,
    height: 20,
    rx: 2.5,
    transform: "translate(572 3956)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Animation_Icon",
    "data-name": "Animation Icon",
    transform: "translate(569 3952.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M106.782,228.53a.882.882,0,0,1-.366-.85c.017-.563,0-1.127,0-1.73h-.447q-2.724,0-5.449,0c-.939,0-1.37-.429-1.372-1.359,0-.429-.007-.858,0-1.286a1.142,1.142,0,0,1,1.219-1.2c1.867-.006,3.733,0,5.6,0h.426v-1.542h-.456q-2.724,0-5.449,0a1.179,1.179,0,0,1-1.342-1.349c0-.416,0-.832,0-1.248a1.142,1.142,0,0,1,1.251-1.241q2.781,0,5.562,0h.423c.054-.425.122-.811-.36-1a.249.249,0,0,1-.058-.048c-1.2-1.02-1.12-.737-1.118-2.34,0-.391-.012-.783.008-1.173a1,1,0,0,1,1.044-1.02c.718-.017,1.438-.016,2.157,0a1.019,1.019,0,0,1,1.066,1.078c.009.668.039,1.34-.015,2a1.492,1.492,0,0,1-.372.821c-.293.322-.711.531-1,.854a2.449,2.449,0,0,0-.277.828h13.2c.946,0,1.349.407,1.35,1.36,0,.441.007.883,0,1.324a1.118,1.118,0,0,1-1.106,1.153c-.126.008-.252,0-.378,0H107.579V222.1h13.029c1,0,1.4.4,1.4,1.39,0,.4,0,.807,0,1.211a1.136,1.136,0,0,1-1.242,1.249c-1.4.006-2.8,0-4.2,0h-9.012c0,.631-.014,1.233.005,1.833a.733.733,0,0,1-.4.746Zm.793-9.133h8.1v-1.515h-8.1Zm5.852,5.4h7.415v-1.545h-7.415Zm-7.026-1.536h-6.08v1.537h6.08Zm-6.091-3.864h6.081v-1.52H100.31Zm7.268,5.4h4.654v-1.54h-4.654Zm13.28-6.92h-4v1.515h4Zm-14.868-5.59c0,.52.031,1.023-.008,1.521-.048.627.488.78.834,1.054.3.236.522-.111.732-.288.166-.14.411-.309.427-.482.053-.6.02-1.2.02-1.8Z",
    transform: "translate(-89.127 -189.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M16.456,0q6.831,0,13.663,0a2.682,2.682,0,0,1,2.733,2.15,3.641,3.641,0,0,1,.056.752q0,6.981,0,13.963a2.69,2.69,0,0,1-2.891,2.912q-10.465,0-20.929,0a2.619,2.619,0,0,1-.3-.01.511.511,0,0,1-.5-.516.517.517,0,0,1,.467-.587,2.542,2.542,0,0,1,.452-.022q10.351,0,20.7,0a3.087,3.087,0,0,0,.714-.053,1.509,1.509,0,0,0,1.151-1.5q.009-7.189,0-14.379a1.546,1.546,0,0,0-1.7-1.571H2.931a1.575,1.575,0,0,0-1.764,1.74q0,7.019,0,14.038A1.562,1.562,0,0,0,2.9,18.642c1.123,0,2.246,0,3.368,0a1.976,1.976,0,0,1,.413.029.555.555,0,0,1-.06,1.1,2.4,2.4,0,0,1-.264.01c-1.161,0-2.321.006-3.482,0A2.68,2.68,0,0,1,.032,16.933Q.027,9.895.032,2.857A2.692,2.692,0,0,1,2.907,0Q9.681,0,16.456,0",
    transform: "translate(-0.027 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    width: 7.8,
    height: 3.85,
    rx: 1,
    transform: "translate(1 33.51)",
    fill: "#f84525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M56.06,58.316a7.32,7.32,0,0,1,3.214-2.026,15.1,15.1,0,0,1,2.26-.4.565.565,0,0,1,.71.545c.009.356-.227.559-.683.58a6.615,6.615,0,0,0-5.066,2.546c-.409.507-.835.465-1.139-.125A9.328,9.328,0,0,0,50.6,54.985a9.223,9.223,0,0,0-3.417-.721.777.777,0,0,1-.52-.146.848.848,0,0,1-.175-.6c.037-.281.285-.388.568-.389a10.055,10.055,0,0,1,3.373.574,10.4,10.4,0,0,1,5.429,4.312c.06.093.125.183.2.3",
    transform: "translate(-41.785 -47.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M3.908,323.537c-.882,0-1.765,0-2.647,0a1.116,1.116,0,0,1-1.248-1.231c0-.492-.008-.983,0-1.474a1.072,1.072,0,0,1,1.1-1.139q2.8-.02,5.6,0a1.077,1.077,0,0,1,1.115,1.129c.008.517.007,1.033,0,1.55a1.1,1.1,0,0,1-1.161,1.164c-.92.01-1.84,0-2.76,0m-2.734-1.158H6.663v-1.542H1.174Z",
    transform: "translate(-0.008 -287.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 7.8,
    height: 3.85,
    rx: 1,
    transform: "translate(1 27.51)",
    fill: "#f84525"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6137",
    "data-name": "Ellipse 6137",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(23 4.51)",
    fill: "#f84525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M3.925,266.462c.895,0,1.79,0,2.684,0a1.1,1.1,0,0,1,1.214,1.217c0,.491.006.983,0,1.474a1.073,1.073,0,0,1-1.1,1.141q-2.8.023-5.6,0a1.07,1.07,0,0,1-1.117-1.126c-.011-.516-.01-1.033,0-1.55a1.078,1.078,0,0,1,1.158-1.157c.92-.008,1.84,0,2.76,0m2.75,1.16H1.168v1.518H6.674Z",
    transform: "translate(0 -239.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M221.5,63.606a3.188,3.188,0,1,1-3.166-3.184,3.188,3.188,0,0,1,3.166,3.184m-1.136.05a2.053,2.053,0,0,0-4.1-.1,2.07,2.07,0,0,0,2.025,2.106,2.049,2.049,0,0,0,2.079-2.007",
    transform: "translate(-193.379 -54.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M46.784,76.468A8.173,8.173,0,0,1,54.577,83a1.681,1.681,0,0,1,.03.225.56.56,0,0,1-1.1.2c-.125-.435-.205-.885-.363-1.306A6.98,6.98,0,0,0,46.821,77.6a2.249,2.249,0,0,1-.264-.011.531.531,0,0,1-.491-.534.522.522,0,0,1,.415-.559,1.3,1.3,0,0,1,.3-.032",
    transform: "translate(-41.409 -68.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M150.683,103.8c.047,0,.148-.007.248,0a.522.522,0,0,1,.541.519.513.513,0,0,1-.467.584c-.309.052-.629.048-.934.117a4.123,4.123,0,0,0-3.148,2.793c-.021.059-.04.119-.062.178a.566.566,0,1,1-1.074-.342,5.338,5.338,0,0,1,4.9-3.851",
    transform: "translate(-131.018 -93.307)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/Animation.a1bd02438644b4a7b63c9a3c7081466d.svg";
export { ForwardRef as ReactComponent };